const getCurrentMonthYear = () => {
    const currentDate = new Date().toLocaleString('en-US', { timeZone: 'Europe/Berlin' });
    return [ new Date(currentDate).getMonth() + 1, new Date(currentDate).getFullYear() ];
};

export default getCurrentMonthYear;